
















































































import {Vue, Component} from 'vue-property-decorator';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import dataProxy from '@/services/data-proxy.service';
import {formatDate, formatDateTime, formatInteger} from "@/utils/formatters";
import moment from 'moment';
import {Aktivnost, EvidencijaAktivnostiVozaca, Osoba} from "@/services/BackendProxies";
import {State} from "vuex-class";

@Component
export default class EvidencijaKretanjaVozila extends mixins(ComponentBaseMixin) {
    isBusy = false;
    gpsLoading = false;
    saving = false;
    aktivnosti: Aktivnost[] = [];
    evidencija = [];
    columns = [];
    options = {pagination: true, search: true, showColumns: true};
    datum = new Date();
    vozac = null;
    filterVisible = false;
    dialogVisible = false;
    model = new EvidencijaAktivnostiVozaca();
    current: EvidencijaAktivnostiVozaca;
    @State zaposleni;
    @State vozila;

    async created() {
        this.aktivnosti = await this.loadData(() => dataProxy.vratiAktivnosti())();
        this.columns = [
            {field: 'nazivAktivnosti', title: this.$i18n.t('aktivnost')},
            {field: 'vozac', title: this.$i18n.t('vozac')},
            {field: 'vozilo', title: this.$i18n.t('vozilo')},
            {field: 'pocetak', title: this.$i18n.t('datumPolaska'), formatter: formatDateTime},
            {field: 'kraj', title: this.$i18n.t('datumZavrsetka'), formatter: formatDateTime},
            {title: this.$i18n.t('trajanjeAktivnosti'), formatter: (_, row: EvidencijaAktivnostiVozaca) =>
                    `${moment(row.kraj).diff(moment(row.pocetak), 'minutes')} min`, align: 'right'},
            {field: 'pocetnaLokacija', title: this.$i18n.t('pocetnaLokacija'), visible: false},
            {field: 'krajnjaLokacija', title: this.$i18n.t('krajnjaLokacija'), visible: false},
            {field: 'kilometrazaPolaska', title: this.$i18n.t('polaznaKM'), formatter: formatInteger, align: 'right', visible: false},
            {field: 'kilometrazaDolaska', title: this.$i18n.t('krajnjaKM'), formatter: formatInteger, align: 'right', visible: false},
            {field: 'predjenoKilometara', title: this.$i18n.t('predjenoKM'), formatter: formatInteger, align: 'right'},
            {field: 'izvor', title: this.$i18n.t('izvor'), formatter: v => this.$i18n.t(v)},
        ]
    }

    get postavljenFilter() {
        return  this.datum || this.vozac;
    }

    toggleFilter() {
        this.filterVisible = !this.filterVisible;
    }

    async pretrazi() {
        if (this.isBusy) return;
        try {
            this.isBusy = true;
            this.evidencija = await this.loadData(() => dataProxy.vratiEvidencijuAktivnostiVozaca(this.datum, this.vozac))();
        } finally {
            this.isBusy = false;
        }
    }

    async ucitajPodatkeSaGps() {
        if (this.gpsLoading) return;
        try {
            this.gpsLoading = true;
            this.evidencija = await this.loadData(() => dataProxy.vratiAktivnostiVozacaIzGps(this.datum, this.vozac))();
        } finally {
            this.gpsLoading = false;
        }
    }

    async sacuvaj() {
        if (this.saving) return ;
        try {
            this.saving = true;
            const evidencija = this.evidencija.filter(x => x.vozacId);
            this.evidencija = await this.saveData(() => dataProxy.sacuvajEvidencijuAktivnostiVozaca(this.datum, this.vozac, evidencija))();
        } finally {
            this.saving = false;
        }
    }

    formatDateTime(value) {
        return formatDateTime(value);
    }

    rowClick(row: EvidencijaAktivnostiVozaca) {
        this.model = EvidencijaAktivnostiVozaca.fromJS(row);
        this.current = row;
        this.dialogVisible = true;
    }

    acceptChanges() {
        this.current.aktivnostId = this.model.aktivnostId;
        this.current.vozacId = this.model.vozacId;
        this.current.voziloId = this.model.voziloId;
        this.current.nazivAktivnosti = this.aktivnosti.find(x => x.id == this.model.aktivnostId).naziv;
        this.current.vozilo = this.vozila.find(x => x.id == this.current.voziloId).text;
        this.current.vozac = this.zaposleni.find(x => x.id == this.current.vozacId).text;
    }

    cancelChanges() {
        this.model = new EvidencijaAktivnostiVozaca();
    }
}
